var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.054,
    height: 80,
    viewBox: "0 0 94.054 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    transform: "translate(-301 -2058)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(311 2058)",
    fill: "#f0d4cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-526.712 1548.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1013.92,665.084h17.1c1.674,0,3.348-.024,5.021.005a9.337,9.337,0,0,1,2.739,18.3,10.193,10.193,0,0,1-2.667.391q-22,.036-44,.014a9.353,9.353,0,0,1-2.2-18.472,11,11,0,0,1,2.191-.225c4.224-.021,8.448-.01,12.672-.01Zm7.234,15.271q6.814,0,13.629,0a12.435,12.435,0,0,0,2.4-.112,5.907,5.907,0,0,0,2.6-10.445,6.569,6.569,0,0,0-4.433-1.32c-3.168.022-6.335.043-9.5.046q-9.932.011-19.864,0c-.393,0-.556.073-.554.517q.026,5.431,0,10.862c0,.383.115.471.488.47Q1013.534,680.345,1021.153,680.355Zm-19.2-11.809c-.187-.011-.287-.023-.386-.023q-4.776,0-9.552,0a5.38,5.38,0,0,0-.8.044,5.92,5.92,0,0,0,.883,11.786q4.6,0,9.2,0h.629v-4.2h-.613c-2.3,0-4.591,0-6.887,0a1.688,1.688,0,0,1-1.88-1.7,1.71,1.71,0,0,1,1.9-1.74c1.625,0,3.25.008,4.875.012.863,0,1.726,0,2.629,0Z",
    transform: "translate(-123.74 -120.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M859.056,516.428a1.69,1.69,0,0,1-1.332,1.672,37.627,37.627,0,0,0-26.608,26.527,1.746,1.746,0,0,1-1.734,1.331,1.712,1.712,0,0,1-1.656-1.477,2.257,2.257,0,0,1,.089-.887,40.965,40.965,0,0,1,21.855-26.156,37.937,37.937,0,0,1,7.122-2.658A1.718,1.718,0,0,1,859.056,516.428Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M885.271,593.449a1.681,1.681,0,0,1-1.675-2.143,28.013,28.013,0,0,1,4.078-8.906,29.241,29.241,0,0,1,16.671-11.876,1.723,1.723,0,1,1,.91,3.308A25.934,25.934,0,0,0,892.59,581.7a25.674,25.674,0,0,0-5.607,10.271A1.724,1.724,0,0,1,885.271,593.449Z",
    transform: "translate(-44.592 -44.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M939.88,639.109a1.686,1.686,0,0,1-1.684-2.094,16.276,16.276,0,0,1,2.094-4.75,16.85,16.85,0,0,1,9.974-7.445,1.708,1.708,0,0,1,2.253,1.169,1.683,1.683,0,0,1-1.3,2.138,14.029,14.029,0,0,0-6.554,4.006,13.315,13.315,0,0,0-3.125,5.641A1.668,1.668,0,0,1,939.88,639.109Z",
    transform: "translate(-88.216 -87.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1111.735,693.85q-7.619,0-15.237.009c-.373,0-.49-.087-.488-.47q.02-5.431,0-10.862c0-.444.161-.517.554-.517q9.932.015,19.864,0c3.168,0,6.336-.025,9.5-.046a6.569,6.569,0,0,1,4.433,1.32,5.907,5.907,0,0,1-2.6,10.445,12.427,12.427,0,0,1-2.4.112Q1118.55,693.859,1111.735,693.85Z",
    transform: "translate(-214.322 -133.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1015.746,682.234v4.177c-.9,0-1.766,0-2.629,0-1.625,0-3.25-.013-4.875-.012a1.71,1.71,0,0,0-1.9,1.74,1.688,1.688,0,0,0,1.88,1.7c2.3,0,4.591,0,6.887,0h.613v4.2h-.629q-4.6,0-9.2,0a5.92,5.92,0,0,1-.883-11.786,5.4,5.4,0,0,1,.8-.044q4.776,0,9.552,0C1015.459,682.211,1015.559,682.223,1015.746,682.234Z",
    transform: "translate(-137.533 -133.802)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.6504be8d4b37edc29da7e3b4c266877e.svg";
export { ForwardRef as ReactComponent };